import React from "react";

export default function SpinnerButton() {

  return (

    <div className="spinner-border text-light" role="status">
      <span className="sr-only"></span>
    </div>

  );
}
